import { fetchData, PaginationResponse } from "@request";
import { getQueryParams } from "@request/helpers";

export type WithdrawalParameters = {
  limit?: number;
  page?: number;
  wallets?: string;
};

export type Withdrawal = {
  id: string;
  address: string;
  commission: number;
  date: string;
  hash: string;
  sum: number;
  status: string;
};

export type WithdrawalsResponse<T = Withdrawal> = PaginationResponse<{
  orders: T[];
}>;

export const getWithdrawalsApi = async <T = Withdrawal>(
  userId: string,
  data?: WithdrawalParameters
) => {
  try {
    const queryParams = getQueryParams(data);

    const response = await fetchData<WithdrawalsResponse<T>>({
      url: `api/v1/for_all_role/withdrawals/${userId}?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("getWithdrawals failed:", error);
    throw error;
  }
};

export type WithdrawalForm = {
  address: string;
  address_id: string;
  amount: number;
};

export type WithdrawalResponse = string;

export const merchantWithdrawalApi = async (
  userId: string,
  data: WithdrawalForm
) => {
  try {
    const response = await fetchData<WithdrawalResponse>({
      url: `api/v1/for_all_role/withdrawals/${userId}`,
      method: "POST",
      data,
    });

    return response;
  } catch (error) {
    console.error("withdrawal failed:", error);
    throw error;
  }
};
